import {
  Component,
  input,
  output,
  HostListener,
  computed,
} from '@angular/core';
import { CommonModule } from '@angular/common';

export interface ModelPopupConfig {
  closeOnOverlayClick?: boolean;
  closeOnEscape?: boolean;
  showCloseButton?: boolean;
  showHeader?: boolean;
}

@Component({
  selector: 'app-model-popup',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './model-popup.component.html',
  styleUrl: './model-popup.component.scss',
})
export class ModelPopupComponent {
  isOpen = input<boolean>(false);
  title = input<string>('');
  config = input<ModelPopupConfig>({
    closeOnOverlayClick: false,
    closeOnEscape: true,
    showCloseButton: true,
    showHeader: true,
  });

  closeModal = output<void>();

  canCloseOnOverlayClick = computed(
    () => this.config().closeOnOverlayClick === true,
  );
  canCloseOnEscape = computed(() => this.config().closeOnEscape !== false);
  showCloseButton = computed(() => this.config().showCloseButton !== false);
  showHeader = computed(() => this.config().showHeader !== false);

  @HostListener('document:keydown.escape', ['$event'])
  onEscapeKey(event: unknown): void {
    if (this.isOpen() && this.canCloseOnEscape()) {
      const e = event as { preventDefault?: () => void };
      if (e.preventDefault) e.preventDefault();
      this.onClose();
    }
  }

  onClose(): void {
    this.closeModal.emit();
  }

  onOverlayClick(): void {
    if (this.canCloseOnOverlayClick()) {
      this.onClose();
    }
  }

  onModalClick(event: MouseEvent): void {
    event.stopPropagation();
  }
}
